<li><span class="term">{{t term}}</span><p class="definition">{{t definition}}{{#if footnote}}<sup>{{footnote}}</sup>{{/if}}</p></li>